import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import LogoImage from '~/components/Shared/Logo/LogoImage';
import LogoSeparator from '~/components/Layout/Footer/LogoSeparator';

export default component$((): JSX.Element => {
  return (
    <div class='flex items-center gap-5 w-full'>
      <LogoSeparator />
      <LogoImage location='footer' />
      <LogoSeparator />
    </div>
  );
});
